/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Embed_Export_Scan_FailedInputs */

const en_audio_embed_export_scan_failed = /** @type {(inputs: Audio_Embed_Export_Scan_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not read track layout: ${i?.error}`)
};

const fr_audio_embed_export_scan_failed = /** @type {(inputs: Audio_Embed_Export_Scan_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossible de lire le tracé des voies : ${i?.error}`)
};

const de_audio_embed_export_scan_failed = /** @type {(inputs: Audio_Embed_Export_Scan_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gleisplan konnte nicht gelesen werden: ${i?.error}`)
};

const it_audio_embed_export_scan_failed = /** @type {(inputs: Audio_Embed_Export_Scan_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile leggere il layout del tracciato: ${i?.error}`)
};

const ru_audio_embed_export_scan_failed = /** @type {(inputs: Audio_Embed_Export_Scan_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось прочитать схему путей: ${i?.error}`)
};

const es_audio_embed_export_scan_failed = /** @type {(inputs: Audio_Embed_Export_Scan_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo leer el trazado de la vía: ${i?.error}`)
};

const zh_cn2_audio_embed_export_scan_failed = /** @type {(inputs: Audio_Embed_Export_Scan_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`无法读取轨道布局：${i?.error}`)
};

const ja_audio_embed_export_scan_failed = /** @type {(inputs: Audio_Embed_Export_Scan_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`トラックレイアウトを読み取れませんでした: ${i?.error}`)
};

const hi_audio_embed_export_scan_failed = /** @type {(inputs: Audio_Embed_Export_Scan_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ट्रैक लेआउट को पढ़ा नहीं जा सका: ${i?.error}`)
};

const pt_pt2_audio_embed_export_scan_failed = /** @type {(inputs: Audio_Embed_Export_Scan_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível ler o layout da pista: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Could not read track layout: {error}" |
*
* @param {Audio_Embed_Export_Scan_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_scan_failed = /** @type {((inputs: Audio_Embed_Export_Scan_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Scan_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_scan_failed(inputs)
	if (locale === "de") return de_audio_embed_export_scan_failed(inputs)
	if (locale === "it") return it_audio_embed_export_scan_failed(inputs)
	if (locale === "ru") return ru_audio_embed_export_scan_failed(inputs)
	if (locale === "es") return es_audio_embed_export_scan_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_scan_failed(inputs)
	if (locale === "ja") return ja_audio_embed_export_scan_failed(inputs)
	if (locale === "hi") return hi_audio_embed_export_scan_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_scan_failed(inputs)
	return en_audio_embed_export_scan_failed(inputs)
});